<template>
  <div class="layout-padding">
    <h5><q-icon name="lock" color="primary" /> Security </h5>
    <div v-if="mode === 'edit' && lastLogin" class="row">
        <p>Last Login: {{ moment(lastLogin).format('llll') }}</p>
    </div>
    <div class="sl-row">
        <q-field class="q-pa-md" v-if="mode === 'edit' && selectedUserId == loggedInUserId">
          <q-input
            float-label="Current Password"
            type="password"
            :error-messages="passwordErrors"
            :value="changePasswordForm.currentPassword"
            @keyup.stop="updateChangePasswordForm({field: 'currentPassword', value: $event.target.value})"
          >
          </q-input>
        </q-field>
        <q-field class="q-pa-md"
          :error="validation.changePasswordForm.password.$error"
          error-label="Length must be between 6 and 20 characters">
          <q-input
            float-label="Set Password"
            type="password"
            :error-messages="passwordErrors"
            :value="changePasswordForm.password"
            @keyup.stop="updateChangePasswordForm({field: 'password', value: $event.target.value})"
            @input="validation.changePasswordForm.password.$touch()"
            @blur="validation.changePasswordForm.password.$touch()"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md"
          :error="validation.changePasswordForm.confirmPassword.$error"
          error-label="Must match set password">
          <q-input
            float-label="Confirm Password"
            type="password"
            :error-messages="confirmPasswordErrors"
            :value="changePasswordForm.confirmPassword"
            @keyup.stop="updateChangePasswordForm({field: 'confirmPassword', value: $event.target.value})"
            @input="validation.changePasswordForm.confirmPassword.$touch()"
            @blur="validation.changePasswordForm.confirmPassword.$touch()"
            required>
          </q-input>
        </q-field>
        <!-- <div class="text-right"> 
          <q-btn
            color="primary"
            v-if="lastLogin"
            label="Change Password"
            @click.native="submitChangePasswordForm(userForm)"
            :disabled="invalid"
          />
          <q-btn
            color="primary"
            label="Set Password"
            v-if="!lastLogin"
            @click.native="submitChangePasswordForm(userForm)"
            :disabled="invalid"
          />
        </div> -->
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import { required, requiredUnless, minLength, maxLength, numeric, sameAs } from 'vuelidate/lib/validators'
import { passwordErrors, confirmPasswordErrors } from 'src/plugins/validations'
const moment = require('moment')

export default {
  name: 'UserSecurity',
  props: ['validation'],
  data () {
    return {
      changePasswordForm: this.$store.state.auth.changePasswordForm,
      lastLogin: this.$store.state.users.userForm.DATE_LAST_LOGIN,
      moment: moment
    }
  },
  computed: {
    ...mapState('users', {
      userForm: state => state.userForm,
      mode: state => state.userModal.mode,
      selectedUserId: state => state.selectedUser.USER_ID
    }),
    ...mapState('auth', {
      loggedInUserId: state => state.user.USER_ID
    }),
    passwordErrors () { return passwordErrors(this.validation.changePasswordForm) },
    confirmPasswordErrors () { return confirmPasswordErrors(this.validation.changePasswordForm) },
    invalid () { return this.validation.changePasswordForm.$invalid }
  },
  methods: {
    ...mapActions('auth', [
      'submitChangePasswordForm'
    ]),
    ...mapMutations('auth', [
      'updateChangePasswordForm'
    ])
  }
}
</script>

<style scoped lang="stylus">
  .q-tabs-panes {
    display: flex;
    // overflow: scroll;
    // max-width: 1400px;
    // margin: auto;
  }
  .sl-row.sl-abs
      height calc(100% - 110px)
</style>
